import useReveal from "@/hooks/useReveal";
import useCountUp from "@/hooks/useCountUp";

function Stat({ value, decimals, suffix, label }) {
  const [displayed, ref] = useCountUp(value, 1800, decimals);
  return (
    <div ref={ref} data-testid={`stat-${label.replace(/\s+/g, "-").toLowerCase()}`}>
      <div className="font-display font-extrabold text-5xl md:text-6xl leading-none tracking-tight">
        {displayed}
        <span className="text-[#ff5722]">{suffix}</span>
      </div>
      <div className="mt-2 text-sm text-black/60 uppercase tracking-wider mono">{label}</div>
    </div>
  );
}

export default function BrandStory() {
  const ref = useReveal();

  return (
    <section
      ref={ref}
      data-testid="brand-story-section"
      className="reveal max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-32"
      id="about"
    >
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-6 relative">
          <div className="relative rounded-3xl overflow-hidden aspect-[4/5] max-w-[520px]">
            <img
              src="https://images.unsplash.com/photo-1552346154-21d32810aba3?auto=format&fit=crop&w=1200&q=85"
              alt="Runner tying laces on urban track at sunrise"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 text-white">
              <span className="mono text-xs uppercase tracking-widest opacity-80">Est. 2019 · Portland, OR</span>
            </div>
          </div>
          {/* Sticker */}
          <div className="hidden md:flex absolute -right-4 top-8 w-32 h-32 rounded-full bg-[#ff5722] text-white items-center justify-center rotate-[12deg] shadow-xl">
            <div className="text-center leading-tight">
              <div className="mono text-[10px] tracking-widest">CARBON</div>
              <div className="font-display font-bold text-2xl">-38%</div>
              <div className="mono text-[10px] tracking-widest">FOOTPRINT</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <span className="mono text-xs uppercase tracking-widest text-[#ff5722]">Our philosophy</span>
          <h2 className="font-display font-extrabold text-4xl md:text-5xl lg:text-6xl leading-[0.95] mt-3 tracking-tight">
            Built by runners.<br />
            Worn by <span className="italic font-light">everyone.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-black/70 leading-relaxed max-w-xl">
            We obsess over the grams, the geometry, and the ground beneath your feet. Every pair is prototyped in our Portland lab, tested by real athletes, then finished by hand — no shortcuts, no compromises.
          </p>

          <div className="mt-12 grid grid-cols-3 gap-6 border-t border-black/10 pt-10">
            <Stat value={2} decimals={0} suffix="M+" label="Pairs sold" />
            <Stat value={4.8} decimals={1} suffix="★" label="Avg rating" />
            <Stat value={48} decimals={0} suffix="" label="Countries" />
          </div>
        </div>
      </div>
    </section>
  );
}
